import $ from 'jquery';


export default class {
	constructor(options) {
		const defaults = {
			el: '.js-brands',
			dom: {
				brandItem: '.js-brand-item',
				asideItem: '.js-aside-item',
				selectOnlineItem: '.js-select-item',
				alphabetItem: '.js-alphabet-item',
				alphabetTitle: '.js-brand-letter-title'
			},
			classes: {
				aside: {
					state: {
						active: 'aside__link_state_active'
					}
				},
				brands: {
					item: {
						hidden: {
							yes: 'brands__item_hidden_yes'
						}
					},
					group: {
						hidden: {
							yes: 'brands__group_hidden_yes'
						}
					}
				},
				alphabet: {
					item: {
						disabled: {
							yes: 'alphabet__item_disabled_yes'
						}
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.isOnline = 'all';
		return this;
	}

	getDom() {
		this.$brandItem = this.$el.find(this.options.dom.brandItem);
		this.$asideItem = this.$el.find(this.options.dom.asideItem);
		this.$selectOnlineItem = this.$el.find(this.options.dom.selectOnlineItem);

	}

	filterBrands(e) {
		e.preventDefault();
		const $currentTarget = $(e.currentTarget);
		this.$asideItem.removeClass(this.options.classes.aside.state.active);
		$currentTarget.addClass(this.options.classes.aside.state.active);
		this.renderOnline();
		this.renderBrands($currentTarget.data('filter'));
		this.renderLetters();
	}

	renderBrands(filter) {
		const self = this;

		filter = parseInt(filter, 10);
		this.$brandItem.each(item => {
			const $currentItem = this.$brandItem.eq(item);
			const itemFilters = String($currentItem.data('filters'));
			const itemFiltersList = itemFilters.split(' ');
			let itemVisible = false;

			for (let i = 0, size = itemFiltersList.length; i < size; i++) {
				if (parseInt(itemFiltersList[i], 10) === filter) {
					itemVisible = true;
					break;
				}
			}

			if (!itemVisible) {
				$currentItem.css('display', 'none');
				$currentItem.addClass(self.options.classes.brands.item.hidden.yes);
			} else {
				$currentItem.css('display', 'list-item');
				$currentItem.removeClass(self.options.classes.brands.item.hidden.yes);
			}
		});
	}

	renderLetters() {
		const emptyLetters = this.getEmtpyLetters();
		const $alphabetItems = $(this.options.dom.alphabetItem);
		const $alphabetTitles = $(this.options.dom.alphabetTitle);
		let $item;
		let letter;
		let $group;

		for (let i = 0, size = $alphabetItems.length; i < size; i++) {
			$item = $alphabetItems.eq(i);
			letter = $item.text().toLowerCase().replace(/[^a-zа-я0-9\-]+/g, '');

			if (emptyLetters.indexOf(letter) !== -1) {
				$item.addClass(this.options.classes.alphabet.item.disabled.yes);
			} else {
				$item.removeClass(this.options.classes.alphabet.item.disabled.yes);
			}
		}

		for (let i = 0, size = $alphabetTitles.length; i < size; i++) {
			$item = $alphabetTitles.eq(i);
			letter = $item.text().toLowerCase().replace(/[^a-zа-я0-9\-]+/g, '');
			$group = $item.closest('.brands__group');

			if (emptyLetters.indexOf(letter) !== -1) {
				$group.addClass(this.options.classes.brands.group.hidden.yes);
			} else {
				$group.removeClass(this.options.classes.brands.group.hidden.yes);
			}
		}
	}

	getEmtpyLetters() {
		const $letters = $(this.options.dom.alphabetTitle);
		const result = [];
		let $letter;
		let $letterBrands;
		let $brand;
		let letterVisibile;

		for (let i = 0, size1 = $letters.length; i < size1; i++) {
			$letter = $letters.eq(i);
			// TODO: вынести селекторы в конфигурацию
			$letterBrands = $letter.closest('.brands__group').find(this.options.dom.brandItem);
			letterVisibile = false;

			for (let j = 0, size2 = $letterBrands.length; j < size2; j++) {
				$brand = $letterBrands.eq(j);
				if (!$brand.hasClass(this.options.classes.brands.item.hidden.yes)) {
					letterVisibile = true;
					break;
				}
			}

			if (!letterVisibile) {
				result.push($letter.text().toLowerCase());
			}
		}

		return result;
	}

	renderOnline() {
		this.$brandItem.each(item => {
			const $currentItem = this.$brandItem.eq(item);
			if (this.isOnline !== 'all' && $currentItem.data('is-online') !== this.isOnline) {
				$currentItem.css('display', 'none');
			} else if (this.isOnline !== 'all' && $currentItem.data('is-online') === this.isOnline) {
				$currentItem.css('display', 'list-item');
			} else if (this.isOnline === 'all') {
				$currentItem.css('display', 'list-item');
			}
		});
	}

	selectIsOnline(e) {
		const $currentTarget = $(e.currentTarget);
		const $item = this.$el.find('.' + this.options.classes.aside.state.active);
		const isOnline = $currentTarget.data('value');
		if (isOnline === 'online') {
			this.isOnline = 1;
		} else if (isOnline === 'ofline') {
			this.isOnline = 0;
		} else {
			this.isOnline = 'all';
		}

		if ($item.length) {
			$item.trigger('click');
		} else {
			this.renderOnline();
		}
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$asideItem.on('click', e => this.filterBrands(e));
			this.$selectOnlineItem.on('click', e => this.selectIsOnline(e));
		}


		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/brands/brands.js
 **/